import { Pipe, PipeTransform, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'checkDate',
  standalone: true,
})
export class CustomDatePipe implements PipeTransform {
  private translocoService = inject(TranslocoService);

  private datePipe = new DatePipe('en-US');

  transform(
    value?: string | null,
    format = 'mediumDate',
    translocoKey?: string,
  ): string {
    if (!value) {
      return translocoKey ? this.translocoService.translate(translocoKey) : '-';
    }
    return this.datePipe.transform(value, format) || '-';
  }
}
